import Vue from "vue";
import ActionDispatcher from './plugins/ActionDispatcher';
import BusHandler from './plugins/BusHandler';
import CpCalculator from "./components/CpCalculator";
import * as bootstrap from 'bootstrap';
import 'slick-carousel';
import AOS from 'aos';
import Parallax from 'parallax-js';

const config = {
    el: '.main',
    components: {
        CpCalculator
    },
    directives: {},
    mixins: [],
    options: {},
    plugins: [
        ActionDispatcher,
        BusHandler
    ],
};

config.plugins.map( ( plugin ) => {
    Vue.use( plugin );
} );

new Vue( config );

$(document).ready(() => {
  $('#scene').each(function() {
    var scene = document.getElementById('scene');
    var parallaxInstance = new Parallax(scene);
  });

  $('#scene2').each(function() {
    var scene2 = document.getElementById('scene2');
    var parallaxInstance2 = new Parallax(scene2);
  });

  setTimeout(function() {
    AOS.init({
      once: true,
      offset: 200, // offset (in px) from the original trigger point
    });
  }, 1200);
  $('.carousel').carousel({
    interval: 4000
  });
  $('body').addClass('nav-show nav-show-top');

  var prevScrollpos = window.pageYOffset;
  window.onscroll = function() {
    var st = $(this).scrollTop();

    var currentScrollPos = window.pageYOffset;
    if (prevScrollpos > currentScrollPos || currentScrollPos == 0) {
      if(currentScrollPos < 240) {
        $('body').addClass('nav-show nav-show-top');
      } else {
        $('body').addClass('nav-show');
      }
    } else {
      if(currentScrollPos > 240) {
        $('body').removeClass('nav-show-top');
      }
    }
    prevScrollpos = currentScrollPos;
  }

  $('.faq_title').on('click', function(e) {
    let number = $(this).attr('data-faq');

    $('.faq_title').each(function() {
      $(this).removeClass('actif');
      if($(this).attr( 'data-faq' ) == number) {
        $(this).addClass('actif');
      };
    });

    $('.faq__answer').each(function() {
      $(this).addClass('d-none');

      if($(this).hasClass( 'faq__answer--' + number )) {
        $(this).removeClass('d-none');
      };
    });
  });
  $('.js-slider-wall').slick({
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 5000,
    prevArrow: '<div class="btn-slider btn-slider-prev"><i class="fas fa-arrow-left"></i></div>',
    nextArrow: '<div class="btn-slider btn-slider-next"><i class="fas fa-arrow-right"></i></div>',
  });

  $('.js-slider').slick({
    infinite: true,
    speed: 300,
    slidesToShow: 1,
    centerMode: false,
    variableWidth: true,
    nextArrow: '<div class="btn--arrow"></div>',
  });

  $('.nav__burger').on('click', function(e) {
    $('body').toggleClass('menu--open');
  });

  $('.menu-item-has-children').on('click', function(e) {
    // e.preventDefault();
    $(this).toggleClass('open');
  });

  $(".mouse").click(function() {
    $('html,body').animate({
        scrollTop: $(".section--big-text").offset().top},
        'fast');
  });

  $('#filterForm').on('click', '.filter__btn' ,function(e) {
    console.log($(this))
    $('#filterForm').submit();
  });
});
